const routes = {
  '/experts/': {
    fetch: () =>
      import(
        /* webpackChunkName: 'team-experts-route' */ 'app/team-experts/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
